import React from 'react';
import ReactPlayer from 'react-player';
import { Helmet } from 'react-helmet';

export default class QuestionnaireComplete extends React.Component {
  render() {
    return (
      <div className="page chat ml-auto p-0 col-md-9 chat-client">
        <div className="generic-page-header">
          <Helmet>
            <title>Questionnaire Complete!</title>
          </Helmet>
          <div className="page--header  col-md-9 ml-auto p-0">
            <div className="header--content  text-white">
              <h1>You’re all set! Click play below.</h1>
            </div>
          </div>
        </div>
        <div className="page--content chat-container">
          <div className="mx-auto col-10 mt-4 player-wrapper">
            <ReactPlayer
              className="react-player"
              url="https://nerdfitness.wistia.com/medias/l2vum8uad5"
              controls
              width="100%"
              height="100%"
            />
          </div>
          <div className="col-md-10 mx-auto mt-4">
            <p>Hey Steve, here!</p>

            <p>
              Did you watch the video above? If you didn’t, click play now
              <b>(seriously, this is your first mission).</b>
            </p>

            <p>
              As I said above, while we don’t have the perfect robot algorithm
              programmed to pair your coaching (BEEP BOOP), we do take time to
              ensure every client is matched by hand with the best coach
              available.
            </p>

            <p>
              I know you are fired up. And I know waiting, especially when you
              are fired up, is the HARDEST THING IN THE WORLD TO DO!!!!!!!!!
            </p>

            <p>
              That said, I do know this is worth it. We’ve seen it over and over
              for clients from all walks of life. I promise that we’ll do
              everything we can to make the wait worth it for you!
            </p>

            <p>
              So next step: give us a little time to line up a great Yoda for
              the journey ahead, and we’ll be in touch soon with details!
            </p>

            {/*  <p>What I need you to do now?</p>

            <p>Check your email. </p>

            <p>
              We’ve sent you a link on how to get started while you wait, along
              with information on access to our digital Academy and basic
              movements you can start to get familiar with if you aren’t
              already.
            </p>

            <p>
              Already making progress? That’s great too - keep that up in while
              we do our thing to get you started. Don’t use this wait time as an
              excuse to lose any momentum.
            </p>

            <p>
              Once again, welcome. On behalf of all of us here on Team Nerd
              Fitness, we’re freakin’ pumped you’ve decided to join the Coaching
              ranks.
            </p>

            <p>
              And we’re all excited to see what you can accomplish over the next
              year or two in the program.
            </p>

            <p>
              Check your email now for more information. And we’ll email again
              when we are ready to get rolling.
            </p> */}

            <p>Signing out!</p>

            <p>-Steve (Rebel One)</p>
          </div>
        </div>
      </div>
    );
  }
}
